import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { ModalWrapper, Stepper, Step } from '@dmm/lib-react-ui-components';
import BDPEmailLeadFormModal from './BDPEmailLeadFormModal';
import BDPQuestionnaire from './BDPQuestionnaire';
import BDPLeadConfirmationModal from './BDPLeadConfirmationModal';
import { nil } from '../../../utils/runOnceHelper';

const BDPStepperModal = (props) => {
  const stepperRef = useRef(null);
  const [userQuestionnaire, setUserQuestionnaire] = useState(null);

  const {
    breakpoint,
    navLinks,
    listings,
    open,
    show,
    onClose,
    customPricingOptions,
    portal,
    listing,
    onSuccess,
    onError = nil,
    featureFlagQuestionnaire,
    shouldConvertCustomLeadHygieneGoal = false,
    skipFirstStep = false,
    sendModalInteraction,
    yearMakeModel
  } = props;

  const shouldShowQuestionnaire = () => {
    const lastShown = localStorage.getItem('questionnaireShown');
    if (lastShown) {
      const now = new Date().getTime();
      const sixtyDays = 60 * 24 * 60 * 60 * 1000;
      return now - lastShown > sixtyDays;
    }
    if (userQuestionnaire && 'shouldShow' in userQuestionnaire) {
      return userQuestionnaire.shouldShow;
    }
    return false;
  };

  const handleSuccess = (userQuestionnaire) => {
    setUserQuestionnaire(userQuestionnaire);
    stepperRef.current?.nextStep();
    onSuccess();
  };

  const handleNextStep = () => {
    localStorage.setItem('questionnaireShown', new Date().getTime());
    stepperRef.current?.nextStep();
  };

  const handleCloseStep = () => {
    localStorage.setItem('questionnaireShown', new Date().getTime());
    onClose();
  };

  useEffect(() => {
    document.body.style.overflow = show ? 'hidden' : 'unset';
  }, [show]);

  if (!show) {
    return null;
  }

  return (
    <div
      data-testid="email-lead-stepper-modal"
      className="email-lead-stepper-modal"
    >
      <ModalWrapper
        show={show}
        onClose={onClose}
        hideCloseButton={true}
        customClassName="stepper-modal-wrapper"
        classNames={{
          stepper: true
        }}
      >
        <Stepper className="stepper" ref={stepperRef}>
          {!skipFirstStep && (
            <Step>
              <BDPEmailLeadFormModal
                onClose={onClose}
                listing={listing}
                portal={portal}
                onSuccess={handleSuccess}
                onError={onError}
                breakpoint={breakpoint}
                shouldConvertCustomLeadHygieneGoal={shouldConvertCustomLeadHygieneGoal}
                featureFlagQuestionnaire={featureFlagQuestionnaire}
                yearMakeModel={yearMakeModel}
              />
            </Step>
          )}
          {featureFlagQuestionnaire && shouldShowQuestionnaire() && (
            <Step>
              <BDPQuestionnaire
                handleCloseClick={handleCloseStep}
                handleDoneClick={handleNextStep}
                handleSkipClick={handleNextStep}
                sendModalInteraction={sendModalInteraction}
                userQuestionnaire={userQuestionnaire}
              />
            </Step>
          )}
          <Step>
            <BDPLeadConfirmationModal
              open={open}
              onClose={onClose}
              breakpoint={breakpoint}
              navLinks={navLinks}
              customPricingOptions={customPricingOptions}
              listings={listings}
            />
          </Step>
        </Stepper>
      </ModalWrapper>
    </div>
  );
};

BDPStepperModal.propTypes = {
  breakpoint: PropTypes.string,
  navLinks: PropTypes.shape({
    next: PropTypes.string,
    previous: PropTypes.string,
    searchUrl: PropTypes.string
  }),
  open: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  listings: PropTypes.array,
  customPricingOptions: PropTypes.object,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  listing: listingPropTypes,
  portal: PropTypes.string,
  shouldConvertCustomLeadHygieneGoal: PropTypes.bool,
  featureFlagQuestionnaire: PropTypes.bool,
  skipFirstStep: PropTypes.bool,
  sendModalInteraction: PropTypes.func,
  yearMakeModel: PropTypes.string
};

export default BDPStepperModal;
